import React from "react";
import { connect } from "react-redux";

import { Button, Modal, Form } from "react-bootstrap";

import { getIntegrationsStart } from "services/redux/actions/enterpriseManager";
import { refreshEnterprisesStart } from "services/redux/actions";

import Alert from "components/Common/Alert";

import Loading from "components/Loading";

import conxtdOut from "apis/conxtdOut";

class AddUptickAuthModal extends React.Component {
  state={
    loading: false,
  }

  render() {
    const { enterpriseId, integrationId } = this.props;
    const { loading } = this.state;

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="modal-60w"
        centered
      >
        <Form onSubmit={(e) => {
          e.preventDefault();

          this.setState({
            loading: true
          });

          conxtdOut.post("/integrations/add", {
              "enterprise_id": enterpriseId,
              "integration_id": integrationId,
              "code": "n/a", 
              "username": e.target.username.value,
              "password": e.target.password.value,
              "subdomain": e.target.subdomain.value,
              "client_id": e.target.client_id.value,
              "client_secret": e.target.client_secret.value
          }).then(() => {
            this.setState({
              loading: false
            });

            this.props.dispatch(
              getIntegrationsStart({
                enterprise_id: enterpriseId,
              })
            );

            this.props.dispatch(
              refreshEnterprisesStart()
            );

            Alert({
              text: "Account connected",
              icon: "success",
              timerProgressBar: true,
              timer: 2000,
            });
            
            this.props.onHide();
          }).catch(error => {
            this.setState({
              loading: false
            });

            Alert({
              text: "Error connecting to Uptick. Please try again later.",
              icon: "error",
              timerProgressBar: true,
              timer: 2000,
            });

            console.log(error);
          });
        }}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Please enter your Uptick account details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Label>Username</Form.Label>
            <Form.Control
              className="mb-3"
              type="text"
              name="username"
              required
            />
            <Form.Label>Password</Form.Label>
            <Form.Control
              className="mb-3"
              type="password"
              name="password"
              required
            />
            <Form.Label>Subdomain</Form.Label>
            <Form.Control
              className="mb-3"
              type="text"
              name="subdomain"
              required
            />
            <Form.Label>Client Id</Form.Label>
            <Form.Control
              className="mb-3"
              type="text"
              name="client_id"
              required
            />
            <Form.Label>Client Secret</Form.Label>
            <Form.Control
              className="mb-3"
              type="text"
              name="client_secret"
              required
            />
          </Modal.Body>
          <Modal.Footer>
            <div className="container">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  {loading && <Loading left />}
                </div>
                <div className="d-flex justify-content-end">
                  <Button
                    className="mr-2 p-2"
                    variant="primary"
                    onClick={this.props.onHide}
                  >
                    Cancel
                  </Button>
                  <Button className="p-2" variant="success"  type="submit">
                    Connect
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}


const mapStateToProps = (state, props) => {
  return {};
};

export default connect(mapStateToProps)(AddUptickAuthModal);